<script>
  export let list
</script>

{#if !list}
<svg class="grid" width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1" fill="white">
<rect width="19.1667" height="8.33333" rx="1"/>
</mask>
<rect width="19.1667" height="8.33333" rx="1" stroke="#F8F1D4" stroke-width="4" mask="url(#path-1-inside-1)"/>
<mask id="path-2-inside-2" fill="white">
<rect x="21.6666" width="8.33333" height="8.33333" rx="1"/>
</mask>
<rect x="21.6666" width="8.33333" height="8.33333" rx="1" stroke="#F8F1D4" stroke-width="4" mask="url(#path-2-inside-2)"/>
<mask id="path-3-inside-3" fill="white">
<rect x="21.6666" y="10.834" width="8.33333" height="8.33333" rx="1"/>
</mask>
<rect x="21.6666" y="10.834" width="8.33333" height="8.33333" rx="1" stroke="#F8F1D4" stroke-width="4" mask="url(#path-3-inside-3)"/>
<mask id="path-4-inside-4" fill="white">
<rect y="10.834" width="8.33333" height="8.33333" rx="1"/>
</mask>
<rect y="10.834" width="8.33333" height="8.33333" rx="1" stroke="#F8F1D4" stroke-width="4" mask="url(#path-4-inside-4)"/>
<path d="M13.3985 11.026L16.8798 11.224L18.908 14.1188L17.9358 17.5364L14.7108 18.8892L11.6535 17.178L11.065 13.6704L13.3985 11.026Z" stroke="#F8F1D4" stroke-width="2"/>
</svg>

{:else}
<svg class="list" width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="4.19971" y1="12.8379" x2="18" y2="12.8379" stroke="#F8F1D4" stroke-width="1.5"/>
<circle cx="1.25" cy="12.7793" r="1.25" fill="#F8F1D4"/>
<line x1="4.19971" y1="7.07324" x2="18" y2="7.07324" stroke="#F8F1D4" stroke-width="1.5"/>
<circle cx="1.25" cy="7.01465" r="1.25" fill="#F8F1D4"/>
<line x1="4.19971" y1="1.30859" x2="18" y2="1.30859" stroke="#F8F1D4" stroke-width="1.5"/>
<circle cx="1.25" cy="1.25" r="1.25" fill="#F8F1D4"/>
</svg>

{/if}

<style lang="scss">
  svg {
    position: relative;
    &.list {
      height: 1em;
      top: 0.15em;
      padding: 0 0.5ex;
    }
    &.grid {
      height: 0.75em;
    }
  }
</style>